var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuineaBissau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 -3.05176e-05C18.1948 -3.05176e-05 16.446 0.240595 14.7825 0.688954L13.0435 20L14.7826 39.311C16.446 39.7593 18.1948 40 19.9999 40C31.0456 40 39.9999 31.0456 39.9999 20C39.9999 8.95434 31.0456 -3.05176e-05 19.9999 -3.05176e-05Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0435 20L14.7826 39.311C16.446 39.7594 18.1948 40 19.9999 40C31.0456 40 39.9999 31.0456 39.9999 20H13.0435Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9999C0 27.5808 4.21797 34.1761 10.4348 37.5681V2.4317C4.21797 5.82373 0 12.419 0 19.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9999C0 29.2405 6.26727 37.016 14.7826 39.311V0.688934C6.26727 2.98393 0 10.7594 0 19.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55739 14.7825L8.85231 18.7682H13.0434L9.65294 21.2316L10.9478 25.2174L7.55739 22.754L4.16685 25.2174L5.462 21.2316L2.07153 18.7682H6.26239L7.55739 14.7825Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuineaBissau);
export default __webpack_public_path__ + "static/media/guinea_bissau.25aad6f1ae1f5203b676d2a9e1930767.svg";
export { ForwardRef as ReactComponent };